import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const PostCardUrlPreview = ({ url }) => {
  const [isLoading, setLoading] = useState(true);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const fetchUrl = async () => {
      const data = await fetch(`/api/og?url=${url}`)
        .then((result) => result.json())
        .catch((err) => {
          console.error(err);
          return false;
        });

      if (data && data.success) {
        setPreview(data);
      }
      setLoading(false);
    };
    fetchUrl();
  }, [url]);

  if (isLoading) {
    return <div className="loading-block has-background-light" />;
  }

  if (preview && preview.ogTitle) {
    let host = '';

    if (url) {
      try {
        host = new URL(url).hostname;
      } catch (err) {
        console.error(err);
      }
    }
    let image = false;
    if (preview.ogImage) {
      if (Array.isArray(preview.ogImage)) {
        image = preview.ogImage[0].url;
      } else {
        image = preview.ogImage.url;
      }
      if (image && image.substring(0, 1) === '//') {
        image = `http:${image}`;
      }
    }

    return (
      <div className="postcard-url-preview">
        <a href={url} target="_blank" rel="noreferrer">
          {image ? (
            <div
              className="preview-url-image"
              style={{
                backgroundImage: `url(${image})`,
              }}
            />
          ) : (
            ''
          )}
          <div className="preview-url-content">
            <div className="preview-url-content-text">
              <h4>{preview.ogTitle}</h4>
              {preview.ogDescription ? <p>{preview.ogDescription}</p> : ''}
            </div>
            <div className="preview-url-website">
              {preview.favicon ? (
                <Image src={preview.favicon} alt="" width={16} height={16} />
              ) : (
                ''
              )}
              <span className="preview-url-website-sitename">{host}</span>
            </div>
          </div>
        </a>
      </div>
    );
  }
  return null;
};

PostCardUrlPreview.propTypes = {
  url: PropTypes.string.isRequired,
};

export default PostCardUrlPreview;
